// eslint-disable-next-line jira/restricted/cookie
import Cookies from 'js-cookie';
/**
 * Returns 'atlassian-token' aka xsrf required to secure some operation.
 * important to read it from cookies - the same source backend will use to validate the operation
 * The attempt to read it from meta(getMeta('atlassian-token')) resulted in HOT-108450
 */
const getXSRFToken = (): string | undefined => Cookies.get('atlassian.xsrf.token');

export default getXSRFToken;
